<template>
  <v-container fluid fill-height>
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-card class="rounded-lg" elevation="1">
          <v-card-title color="#f8f9fb" elevation="0">
            <v-row align="center" no-gutters>
              <v-col cols="auto">
                <span class="text-h6 font-weight-regular">{{
                  $t("securityguard.title")
                }}</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col cols="12" sm="4" md="3" class="px-3">
                <v-text-field
                  v-model="search"
                  label="Search"
                  append-icon="mdi-magnify"
                  single-line
                  hide-details
                  clearable
                  @input="
                    sessionStorage(search);
                    debounceInput();
                  "
                ></v-text-field>
              </v-col>
              <v-col cols="auto">
                <router-link to="/societyadmin/securityguard/add" tag="button">
                  <v-btn class="primary">
                    <v-icon left> mdi-plus </v-icon>
                    Add Security Guard
                  </v-btn>
                </router-link>
              </v-col>
            </v-row>
          </v-card-title>
          <v-divider></v-divider>
          <v-data-table
            :headers="headers"
            :items="securityguards"
            :search="search"
            :options.sync="options"
            :server-items-length="totalRecords"
            :loading="loading"
            :page.sync="page"
          >
               <template v-slot:item.profile_url="{ item }">
                <v-avatar
                  size="40"
                  v-if="item && item.profile_url != null"
                  class="mb-3 mt-3"
                >
                  <v-img
                    :src="API_BASE_URL + '/uploads/' + item.profile_url"
                    :alt="item.name"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey lighten-5"
                        ></v-progress-circular>
                      </v-row>
                    </template>
                  </v-img>
                </v-avatar>
                <v-avatar
                  v-else
                  color="primary  primary--text"
                  class="white--text mb-3 mt-3"
                  size="40"
                >
                  <span class="fontsize-11 white--text">{{
                    item.name ? item.name.charAt(0) : ""
                  }}</span>
                </v-avatar>
              </template>
              <template v-slot:item.name="{ item }">
                {{ item.name }}
              </template>
              <template v-slot:item.mobile_no="{ item }">
                {{ (item.country_code) }} {{ item.mobile_no }}
              </template>
              <template v-slot:item.email="{ item }">
                {{ item.email ? item.email : 'N/A' }}
              </template>
              <template v-slot:item.actions="{ item }">
                <v-btn
                  icon
                  color="secondary"
                  name="edit_securityguard"
                  title="Edit Security Guard"
                  style="margin-left: -10px"
                  :to="'/societyadmin/securityguard/edit/' + item.id"
                >
                  <img src="@/components/icons/edit-02.svg" width="18" height="18" />
                </v-btn>
                <v-btn
                  icon
                  color="secondary"
                  name="delete_securityguard"
                  title="Delete Security Guard"
                  @click="confirmDelete(item.id)"
                >
                  <img src="@/components/icons/delete-01.svg" width="18" height="18" />
                </v-btn>
              </template>
            </v-data-table>
        </v-card>
      </v-flex>
      <v-dialog v-model="deleteDialog" width="500">
        <v-card>
          <v-card-title class="text-h5 grey lighten-2">
            Confirm!!
          </v-card-title>
          <v-card-text class="mt-2"> Are you sure want to delete? </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="deleteSecurityGuard()">
              yes
            </v-btn>
            <v-btn color="primary" text @click="deleteDialog = false">
              No
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
import { debounce } from "lodash";
import { mapMutations } from "vuex";

export default {
  data() {
    return {
      search: "",
      headers: [
        {
          text: `${this.$t("securityguard.headers.profile_url")}`,
          value: "profile_url",
          sortable: false,
          search: false,
        },
        {
          text: `${this.$t("securityguard.headers.name")}`,
          value: "name",
        },
        {
          text: `${this.$t("securityguard.headers.mobile_no")}`,
          value: "mobile_no",
          class: "text-truncate",
        },
        {
          text: `${this.$t("securityguard.headers.email")}`,
          value: "email",
        },
        {
          text: `${this.$t("securityguard.headers.actions")}`,
          value: "actions",
          sortable: false,
          width: "15%",
        },
      ],
      user: {},
      addPermissionDialog: false,
      deleteDialog: false,
      securityguards: [],
      delete_id: "",
      options: {
        sortBy: ["created_at"]
      },
      totalRecords: 0,
      loading: false,
      page: 1,
    };
  },
  watch: {
    options: {
      handler () {
        this.getSecurityGuards();
      },
      deep: true,
    }
  },
  methods: {
    ...mapMutations("alert", ["setAlert"]),
    getSecurityGuards() {
      this.loading = true;
      let page = this.options.page;
      let itemsPerPage = this.options.itemsPerPage;
      let sortBy = this.options.sortBy.length > 0 ? this.options.sortBy[0] : "";
      let sortDesc = this.options.sortDesc.length > 0 ? this.options.sortDesc[0] : "";
      let search = this.search ? this.search : "";

      let _self = this;
      _self.$axios
        .get("societyadmin/securityguard?society_id=" + _self.user.id+
            "&page=" + page +
            "&perPage=" + itemsPerPage +
            "&sortBy=" + sortBy +
            "&sortDesc=" + sortDesc +
            "&search=" + search
        )
        .then((response) => {
          _self.loading = false;
          let data = response.data;
          
          if (data.status) {
            _self.securityguards = data.securityguards;
            _self.totalRecords = data.total;
            _self.page = data.page > data.lastPage ? 1 : data.page;
          } else {
            _self.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    deleteSecurityGuard() {
      let _self = this;
      _self.$axios
        .delete("societyadmin/securityguard/" + this.delete_id)
        .then((response) => {
          let data = response.data;

          if (data.status) {
            this.getSecurityGuards();
            this.deleteDialog = false;

            this.setAlert({
              showAlert: true,
              variant: "green accent-4",
              timeout: "2000",
              message: data.message,
            });
          } else {
            this.setAlert({
              showAlert: true,
              variant: "red accent-3",
              timeout: "2000",
              message: data.message,
            });
          }
        });
    },
    sessionStorage(search) {
      if (search === null || search === "" || search === undefined) {
        sessionStorage.removeItem("securityguard_search");
      } else {
        const trimmedSearch = search.trim();
        this.search = trimmedSearch;
        sessionStorage.setItem("securityguard_search", trimmedSearch);
      }
    },
    confirmDelete(id) {
      (this.deleteDialog = true), (this.delete_id = id);
    },
    debounceInput: debounce(function(){
      this.getSecurityGuards();
    }, 500),
  },
  mounted() {
    this.user = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))
      : {};
    this.getSecurityGuards();
    this.search = sessionStorage.getItem("securityguard_search");
  },
};
</script>
